import { createSwrSingletonStore } from './swr/createSwrSingletonStore';
import { getBillingUsage } from '../lib/api';

const swr = createSwrSingletonStore({
  name: 'BillingStore',
  storageKey: 'bookthing-billing',
  fetcher: async () => {
    const usage = await getBillingUsage();
    return usage || {};
  },
});

export const useBillingStore = swr.useStore;
export const useBillingData = swr.useData;
export const fetchBillingIfStale = swr.fetchIfStale;
